import {
	vh,
	startTypeShuffle,
	utils,
	startWhichSizeVideo,
	scrubVideoOnScroll,
	whichSizeVideo, toggleModalSketch,
	addVhMarkers
} from '../components/utils';
import {gsapContext} from '../components/theme-scripts';

export function templateMembershipInit() {

	const section1Panel0 = document.querySelector('.section-1__panel--0');
	const section2       = document.querySelector('.section-2');
	const section2Panel0 = document.querySelector('.section-2__panel--0');
	const section3       = document.querySelector('.section-3');
	const section3Panel0 = document.querySelector('.section-3__panel--0');

	//addVhMarkers();

	gsapContext.add(() => {

		startWhichSizeVideo(section1Panel0);

		ScrollTrigger.create({
			trigger:     section2,
			start:       () => 'top 50%',
			end:         () => 'bottom 10%',
			toggleClass: 'trigger-1',
			//markers:  true
		});


		/**
		 * Triggers for the section 2 panels
		 */

		ScrollTrigger.create({
			trigger:     section2Panel0,
			start:       () => 'top 50%',
			end:         () => 'bottom 50%',
			toggleClass: 'trigger-1',
			//markers:  true
		});


		/**
		 * Animations for memberships
		 */

		let memberships = gsap.utils.toArray(".membership");

		let gsapMatchmedia = gsap.matchMedia();

		gsapMatchmedia.add({
			isDesktop: '(min-width: 992px)',
			isTablet:  '(min-width: 768px) and (max-width: 991.98px)',
			isMobile:  '(max-width: 767.98px)'

		}, (context) => {

			let { isMobile} = context.conditions;

			let scrollTween = gsap.to(memberships, {
				xPercent:      -100 * (memberships.length - 1),
				ease:          "none",
				scrollTrigger: {
					trigger: section3Panel0,
					pin:     true,
					scrub:   1,
					//snap: directionalSnap(1 / (sections.length - 1)),
					start: () => 'top top',
					end:   () => isMobile ? '+=' + vh(300) : '+=' + vh(600),
					//markers: true
				}
			});

			ScrollTrigger.create({
				trigger:            memberships[0],
				start:              () => 'top center',
				end:                () => 'right center',
				onEnter:            ({progress, direction, isActive}) => {
					memberships[0].classList.add('trigger-1');
				},
				//markers: {startColor: 'yellow', endColor: 'yellow', indent: 50}
			});

			let i = 0;

			memberships.forEach((membership) => {

				ScrollTrigger.create({
					trigger:            membership,
					containerAnimation: scrollTween,
					start:              () => 'left center',
					end:                () => 'right center',
					toggleClass:        'trigger-1',
					//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
				});


				let membershipVideoScrollTriggerStart = (i === 0) ? 'center center' : 'left center';
				let membershipVideoScrollTriggerEnd   = (i === 0) ? 'center left' : 'left left';

				let membershipVideoScrollTrigger = {
					trigger:            membership,
					containerAnimation: scrollTween,
					start:              () => membershipVideoScrollTriggerStart,
					end:                () => membershipVideoScrollTriggerEnd,
					scrub:              1,
					//markers:            true
				}

				let videoKey = membership.querySelector('video');

				if (videoKey !== null)
				{
					whichSizeVideo(videoKey);

					scrubVideoOnScroll(videoKey, membershipVideoScrollTrigger);
				}

				i++;
			})

		});

	});


}